/* Built In Imports */

/* External Imports */
import { Box, Grid } from '@chakra-ui/react';
import SingleImage from '@components/Card/SingleImage';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/**
 * Renders the IshangaPoemSection component
 *
 * @param {object} sectionContent - Data for section
 * @param sectionContent.section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} IshangaPoemSection component
 */
const IshangaPoemSection = ({ section, region, lang }) => {
  // consoleLog(section, 'ishanga poem section');
  return (
    <Box mb="60px">
      <SectionTitle titleObj={section.sectionContent?.[0]} />
      <Box w="100%" height="100%">
        <Grid
          placeItems={'center'}
          //   templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
          gridGap="30px"
        >
          <style>
            {`
              .IshangaPoemSec p:last-child{
                    margin-top:10px;
                  }
                .IshangaPoemSec{
                    text-align:center;
                }
                
                .IshangaPoemSec h2{
                    color:#F0951D !important;
                    text-align:center !important;
                    font-size: 30px !important;
                    height: 40px !important;
                    margin-top: 90px !important;
                    margin-bottom:30px;
                }
                .IshangaPoemSec p{
                    color:#FFEFDB;
                    text-align:center;
                    font-weight: 400;
                    font-size: 22px !important;
                    line-height: 30px;
                    font-style: italic;
                    display: flex;
                    place-content: center;
                }
                @media only screen and (max-width: 360px) {
                  .IshangaPoemSec h2 {
                    font-size: 27px !important;
                  }
                  .IshangaPoemSec p{
                    line-height:34px;
                    color:#ffffff;
                  }
                }

                `}
          </style>
          <StructuredTextParser
            className="event-text IshangaPoemSec"
            color="white"
            str={render(section.sectionContent[0]?.body)}
            region={region}
            lang={lang}
          />
          <SingleImage my="0" sectionContent={section.sectionContent[1]} />
        </Grid>
      </Box>
      {/* </StyleConfig> */}
    </Box>
  );
};

export default IshangaPoemSection;
